import { render } from "./ReactionsList.vue?vue&type=template&id=bcb8ebce&scoped=true"
import script from "./ReactionsList.vue?vue&type=script&lang=js"
export * from "./ReactionsList.vue?vue&type=script&lang=js"

import "./ReactionsList.vue?vue&type=style&index=0&id=bcb8ebce&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcb8ebce"]])

export default __exports__